module.exports = __webpack_public_path__ + "img/detailtwo_title.4edda882.png";